/**
 * Vite browser entry.
 */
import './lib/vite/client/dev-preamble'
import runApp from './lib/browser'

runApp()
